import { render, staticRenderFns } from "./JSuperQuery.vue?vue&type=template&id=34a33cde&scoped=true"
import script from "./JSuperQuery.vue?vue&type=script&lang=js"
export * from "./JSuperQuery.vue?vue&type=script&lang=js"
import style0 from "./JSuperQuery.vue?vue&type=style&index=0&id=34a33cde&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a33cde",
  null
  
)

export default component.exports